export function isNumber(value: number | string | undefined | null): value is number {
  return typeof value === 'number' && !Number.isNaN(value);
}
